import { IUser } from '../users/user';
import { PayloadTypes } from '../../services/api';

export enum LoggingMode {
  Social,
  Credentials,
  None,
}

export type AuthState = {
  token: string;
  loading: boolean;
  isLoggedIn: boolean;
  error: string | null;
  userId: string | null;
  uniqueSession: boolean;
  user: IUser | null;
  originalUser: IUser | null;
  originalToken: string;
  displayImpersonateModal: boolean;
  loadingImpersonate: boolean;
  payloadType: PayloadTypes | null;
  hash: string | null;
  loggingMode: LoggingMode;
  redirectUrl: string;
  webClientId: string | null;
  // use for Features.PlgExternal
  accountUsage?: number | null;
  updateProspectCredentials: {
    showReCaptchaV2: boolean;
  };
  // end of use for Features.PlgExternal
  showReCaptchaV2ForLogin?: boolean;
};

export const initialState: AuthState = {
  token: '',
  isLoggedIn: false,
  loading: false,
  error: null,
  userId: null,
  user: null,
  originalUser: null,
  uniqueSession: true,
  originalToken: '',
  displayImpersonateModal: false,
  loadingImpersonate: false,
  payloadType: null,
  hash: null,
  loggingMode: LoggingMode.None,
  redirectUrl: '',
  webClientId: null,
  accountUsage: null,
  updateProspectCredentials: {
    showReCaptchaV2: false
  },
  showReCaptchaV2ForLogin: false
};
